// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3-0d6","tab":"Tabs_tab__3vXrC","tabActive":"Tabs_tabActive__3I4SJ"};